import breakpoints from './breakpoints';
import palette from './palette';
import shadows from './shadows';
import space from './space';
import tokens from './tokens';
import variables from './variables';

const defaultTheme = { palette, space, breakpoints, shadows, variables, tokens };

export default defaultTheme;
